/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { UnitDependencies } from './dependenciesUnitClass.generated.js';
import { createElectronMass } from '../../factoriesAny.js';
export var electronMassDependencies = {
  BigNumberDependencies,
  UnitDependencies,
  createElectronMass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesElectronMass.generated.js
// module id = Sw+b
// module chunks = 3